export const refs = {
  form: document.querySelector('.header-form'),
  taskList: document.querySelector('.tasks-list') 
};
